import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#select-any-level-of-options" }),
  /*#__PURE__*/_createTextVNode(" Select any level of options ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " In single selection, only the leaf nodes can be checked, and in multiple selection, check parent nodes will lead to leaf nodes be checked eventually. When enable this feature, it can make parent and child nodes unlinked and you can select any level of options. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = { class: "block mb-5" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", {
  class: "demonstration",
  style: {"margin-right":"5px"}
}, "Select any level of options (Single selection)", -1)
const _hoisted_7 = { class: "block" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", {
  class: "demonstration",
  style: {"margin-right":"5px"}
}, "Select any level of options (Multiple selection)", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_cascader = _resolveComponent("el-cascader")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_el_cascader, {
          options: _ctx.options,
          props: { checkStrictly: true },
          clearable: ""
        }, null, 8, ["options"])
      ]),
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_el_cascader, {
          options: _ctx.options,
          props: { multiple: true, checkStrictly: true },
          clearable: ""
        }, null, 8, ["options"])
      ]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code6), 1)
        ]),
        _: 1
      })
    ])
  ]))
}